import styled from "styled-components";

export const StyleScrollBarTextArea = styled.div`
	textarea::-webkit-scrollbar {
		width: 5px;
	}

	textarea::-webkit-scrollbar-thumb {
		background-color: rgba(0, 0, 0, 0.2);
		border-radius: 4px;
	}

	textarea::-webkit-scrollbar-track {
		background-color: transparent;
	}
`;
